export default __webpack_public_path__ + "static/media/qr_portal.76f2a1c0.png";